import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  SelectPicker,
  DatePicker,
  Table,
  Uploader,
  Icon,
  ButtonGroup,
  IconButton,
  Modal,
  Button,
} from 'rsuite'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import {
  isValidators,
  requiredFiled,
  isImageOrPdf,
  isSupportFileType,
} from '../../../utils/ValidatorUtils'
import AppContext from '../../../context/AppContext'
import classNames from 'classnames'
import { isEmpty } from 'lodash-es'
import TooltipButton from '../../../components/buttons/TooltipButton'

export default function ProjectTrackingNoteForm({
  schema: _schema,
  schemaAttachFiles: _schemaAttachFiles,
  schemaNoteForm: _schemaNoteForm,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  handelPreview,
  isChangSeqNo = true,
  onChangSeqNo = () => {},
  onPreview,
  onDownload,
  onUpdate,
  onDelete,
  isEdit,
  disableTableFiles,
  ...props
}) {
  const { theme } = React.useContext(AppContext)
  const { Column, HeaderCell, Cell } = Table
  const { isEditErr, isUploadErr, isDeleteError, loading, disabledUpload, disabledEdit } = props

  const [schema, setSchema] = useState(_schema)
  const [dataDate, setDataDate] = useState(null)
  const [schemaAttachFiles, setSchemaAttachFiles] = useState(_schemaAttachFiles)
  const [selectEditeIndex, setSelectEditeIndex] = useState(-1)
  const [schemaNoteForm, setSchemaNoteForm] = useState(_schemaNoteForm)
  const [uploadfileList, setUploadfileList] = useState([])
  const [editName, setEditName] = useState()

  const [isAdd, setIsAdd] = useState(false)
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isUploadError, setIsUploadError] = useState(false)
  const [isEditError, setIsEditError] = useState(false)
  const [isdelete, setIsdelete] = useState(false)
  const [supportFileError, setSupportFileError] = useState(false)
  const [isOverSize, setIsOverSize] = useState(false)
  const [isNotSupportType, setIsNotSupportType] = useState(false)
  const [deleteIndex, setDeleteIndex] = useState()

  const defaultSupportType = '.jpg, .jpeg, .png, .pdf'

  useEffect(() => {
    setSchemaAttachFiles(_schemaAttachFiles)

    if (!isEditErr) {
      setEditName()
      setSelectEditeIndex(-1)
    }
  }, [_schemaAttachFiles])

  useEffect(() => {
    if (_schemaNoteForm) {
      setValue(_schemaNoteForm.note.name, _schemaNoteForm.note.value || '')
      setValue(_schemaNoteForm.date.name, _schemaNoteForm.date.value || null)
      _schemaNoteForm?.notiStatus?.name &&
        setValue(_schemaNoteForm.notiStatus.name, _schemaNoteForm.notiStatus.value || null)

      setValue('file', [])

      setSchemaNoteForm(_schemaNoteForm)
    }
  }, [_schemaNoteForm])

  const handleEditFile = (rowData, index) => {
    setEditName(rowData.label)
    setSelectEditeIndex(index)
  }

  const handleDeleteFile = (index) => {
    setDeleteIndex(index)
    setIsdelete(true)
  }

  const validateEditFileName = (rowData, index) => {
    if (selectEditeIndex == index) {
      return (
        <Row>
          {isEditError && (
            <Col style={{ marginBottom: 10 }}>
              <Message
                showIcon
                type="error"
                description={`แก้ไขไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
              />
            </Col>
          )}
          <Col xs={19} sm={19} md={19} lg={19}>
            <Input value={editName} onChange={(value) => setEditName(value)} />
          </Col>
          <Col xs={5} sm={5} md={5} lg={5}>
            <ButtonGroup>
              <IconButton
                appearance="ghost"
                icon={<Icon icon="check" className="bt-gost-icon-radius" />}
                onClick={(e) => {
                  onUpdate(rowData, editName)
                }}
              />
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-cancel"
                icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
                onClick={(e) => {
                  setEditName('')
                  setIsEditError(false)
                  setSelectEditeIndex(-1)
                }}
              />
            </ButtonGroup>
          </Col>
        </Row>
      )
    } else {
      return rowData.label
    }
  }

  return (
    <>
      {schemaNoteForm && (
        <Form>
          <Row>
            <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: '5px', padding: '8px' }}>
              <ErrorMessage error={errors[schemaNoteForm?.note?.name]} />
              <ControlLabel>
                {requiredFiled(schemaNoteForm.note.validators, 'รายละเอียดการติดตาม')}
              </ControlLabel>
              <Input
                name={schemaNoteForm.note.name}
                rows={3}
                componentClass="textarea"
                defaultValue={schemaNoteForm?.note?.value || ''}
                placeholder={'รายละเอียดการติดตาม'}
                inputRef={register(isValidators(schemaNoteForm.note.validators))}
              />
            </Col>
            <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: '5px', padding: '8px' }}>
              <ErrorMessage error={errors[schemaNoteForm.date.name]} />
              <ControlLabel>
                {requiredFiled(schemaNoteForm.date.validators, schemaNoteForm.date.label)}
              </ControlLabel>
              <Controller
                name={schemaNoteForm.date.name}
                control={control}
                defaultValue={schemaNoteForm.date.value ? schemaNoteForm.date.value : null}
                rules={isValidators(schemaNoteForm.date.validators)}
                render={(props) => {
                  return (
                    <DatePicker
                      format="DD/MM/YYYY"
                      locale={LOCAL_DAY_TH}
                      block
                      value={props.value}
                      onChange={(date) => {
                        props.onChange(date)
                      }}
                    />
                  )
                }}
              />
            </Col>

            {schemaNoteForm.notiStatus && (
              <Col lg={12} md={12} sm={24} xs={24} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schemaNoteForm.notiStatus.name]} />
                <ControlLabel>
                  {requiredFiled(schemaNoteForm.notiStatus.validators, schema.notiStatus.label)}
                </ControlLabel>
                <Controller
                  name={schemaNoteForm.notiStatus.name}
                  control={control}
                  rules={isValidators(schemaNoteForm.notiStatus.validators)}
                  defaultValue={
                    schemaNoteForm?.notiStatus?.value ? schemaNoteForm?.notiStatus?.value : null
                  }
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={schemaNoteForm.notiStatus.options}
                        style={{ width: '100%' }}
                        searchable={false}
                        value={props.value}
                        placeholder={schemaNoteForm.notiStatus.hint}
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            )}

            <>
              <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: '5px', padding: '8px' }}>
                <Controller
                  name={'file'}
                  control={control}
                  defaultValue={undefined}
                  render={(props) => {
                    return (
                      <Uploader
                        draggable
                        autoUpload={false}
                        multiple={false}
                        fileList={props.value || []}
                        onChange={(fileList) => {
                          if (isEmpty(fileList)) {
                            props.onChange(undefined)
                          } else {
                            if (disableTableFiles) {
                              let files = []
                              files.push(fileList[fileList.length - 1])
                              props.onChange(files)
                            } else {
                              props.onChange(fileList)
                            }
                          }
                        }}
                      >
                        <div>
                          <div
                            style={{ lineHeight: '50px' }}
                            className={classNames('uploader', `${theme[0]}-background`)}
                          >
                            <Icon size="4x" icon="upload2" />
                            <small className="uploder__text">
                              <p style={{ wordBreak: 'break-word' }}>
                                คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                              </p>
                            </small>
                          </div>
                        </div>
                      </Uploader>
                    )
                  }}
                />
              </Col>
            </>

            {!disableTableFiles && (
              <>
                <Col lg={24} md={24} sm={24} xs={24} style={{ marginTop: '5px', padding: '8px' }}>
                  <Table
                    height={300}
                    wordWrap
                    bordered
                    data={schemaAttachFiles?.value || (isEdit ? schemaAttachFiles?.values : [])}
                  >
                    <Column width={90} align="center" fixed>
                      <HeaderCell>ไฟล์ที่</HeaderCell>
                      <Cell>
                        {(_, index) => {
                          return index + 1
                        }}
                      </Cell>
                    </Column>
                    <Column minWidth={300} flexGrow={1}>
                      <HeaderCell>ชื่อไฟล์</HeaderCell>
                      <Cell>
                        {(rowData, index) => {
                          return validateEditFileName(rowData, index)
                        }}
                      </Cell>
                    </Column>

                    <Column width={200} align="center">
                      <HeaderCell></HeaderCell>
                      <Cell>
                        {(rowData, index) => {
                          return (
                            <ButtonGroup>
                              <TooltipButton
                                isStart={true}
                                icon="eye"
                                tooltip={`แสดง`}
                                // disabled={loading}
                                onClick={(e) => onPreview(rowData)}
                              ></TooltipButton>
                              <TooltipButton
                                isStart={false}
                                icon="download"
                                tooltip={`ดาวน์โหลด`}
                                // disabled={loading}
                                onClick={(e) => onDownload(rowData)}
                              ></TooltipButton>
                              {!disabledEdit && (
                                <TooltipButton
                                  isStart={false}
                                  icon="pencil"
                                  tooltip={`แก้ไข`}
                                  disabled={selectEditeIndex == index}
                                  onClick={(e) => handleEditFile(rowData, index)}
                                ></TooltipButton>
                              )}
                              <TooltipButton
                                isStart={false}
                                icon="trash-o"
                                tooltip={`ลบ`}
                                // disabled={loading}
                                onClick={(e) => handleDeleteFile(index)}
                              ></TooltipButton>
                            </ButtonGroup>
                          )
                        }}
                      </Cell>
                    </Column>
                  </Table>
                </Col>
              </>
            )}
          </Row>
          <Modal
            show={isdelete}
            onHide={(e) => {
              setIsdelete(false)
            }}
          >
            <Modal.Header>
              <Modal.Title>ยืนยันการลบ</Modal.Title>
            </Modal.Header>
            <Modal.Body>{'ยืนยันการลบไฟล์'}</Modal.Body>
            <Modal.Footer>
              <Button
                onClick={(e) => {
                  onDelete(deleteIndex)
                  setIsdelete(false)
                }}
                appearance="primary"
              >
                ลบ
              </Button>
              <Button
                onClick={(e) => {
                  setIsdelete(false)
                  setDeleteIndex('')
                }}
                appearance="subtle"
              >
                ยกเลิก
              </Button>
            </Modal.Footer>
          </Modal>
        </Form>
      )}
    </>
  )
}
